import classNames from 'classnames';

import ItemCount from '../typography/ItemCount';
import LocationTypeIcon from './LocationTypeIcon';

import styles from '../../styles/icons/locations-count.module.css';

interface LocationsCountIconProps {
    count?: number | null;
    color?: string;
    iconCircleColor?: string;
    countClassName?: string | null;
    className?: string | null;
}

function LocationsCountIcon({
    count = null,
    color = '#222',
    iconCircleColor = 'transparent',
    countClassName = null,
    className = null,
}: LocationsCountIconProps) {
    return (
        <div className={classNames([styles.container, className])}>
            <LocationTypeIcon color={color} circleColor={iconCircleColor} className={styles.icon} />
            {count !== null && count > 0 ? (
                <span className={classNames([styles.count, countClassName])}>
                    <ItemCount>{count}</ItemCount>
                </span>
            ) : null}
        </div>
    );
}

export default LocationsCountIcon;
